import React from 'react';
import { FormattedMessage as Trans } from 'react-intl';

import { usePreferences } from '../hooks/usePreferences';

import BlockContent from './BlockContent';

export default function PreferencesStep2() {
  const { allOptOut, back } = usePreferences();

  return (
    <>
      <BlockContent
        content={{
          headingTwo: (
            <Trans
              id={
                !allOptOut
                  ? 'preferencesChangesSavedTitle'
                  : 'preferencesThankYouTitle'
              }
            />
          ),
          description: (
            <Trans
              id={
                !allOptOut
                  ? 'preferencesChangesSavedDescription'
                  : 'preferencesThankYouDescription'
              }
            />
          ),
          buttons: [
            {
              onClick: back,
              version: 'tertiary-text',
              label: <Trans id="buttonLabelBackToEmailPreferences" />
            },
            {
              version: 'primary',
              externalLink: 'quoting',
              label: <Trans id="buttonLabelQuote" />
            }
          ]
        }}
      />
    </>
  );
}
